import React, { FC, useMemo } from 'react';
import { TextButton } from '../TextButton';
import { useBrandGroupConfig } from '../../hooks/useBrandGroupConfig';
import { useQueryParams } from '../../hooks/useQueryParams';
import { useTranslation } from 'react-i18next';

export type CountryTextButtonProps = {
  onClick: () => void;
};

export const CountryTextButton: FC<CountryTextButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();
  const { brand } = useQueryParams();
  const { getBrandConfigFromBrandId } = useBrandGroupConfig();

  const brandCountryISO = useMemo(() => {
    if (!brand) {
      return undefined;
    }
    const countryISO = getBrandConfigFromBrandId(brand)?.countryISO;
    return countryISO;
  }, [brand, getBrandConfigFromBrandId]);

  const changeCountryMessage = useMemo(() => {
    return `${t('register.country.linkText')} ${t(`register.country.ISO.${brandCountryISO}`)}`;
  }, [brandCountryISO, t]);

  return !brandCountryISO ? null : (
    <TextButton
      textStyling={{
        className: 'm-0 p-0 grey-60',
        style: {
          'text-decoration': 'underline',
          fontStyle: 'normal',
          fontWeight: 'regular',
          fontSize: '14px',
        },
      }}
      onClick={onClick}
      message={changeCountryMessage}
      selector="switchCountryTextButton"
    />
  );
};
